import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import lsDel from 'utils/dom/storage/lsDel.util';
import lsGet from 'utils/dom/storage/lsGet.util';
import lsSet from 'utils/dom/storage/lsSet.util';
import logger from 'utils/logger.util';

const L = logger('quickfix'); // eslint-disable-line no-unused-vars

const PREFIX = '__quickfix__';

const KEY = Object.freeze({
  1: `${PREFIX}timelineZone`,
  2: `${PREFIX}timelineOffset`,
});

const k = (args) => KEY[fromAnyToTrimmed(args[0])];

const quickfix = (...args) => {
  if (!args.length) return;

  const key = k(args);
  if (!key) return;

  if (1 === args.length) return lsGet(key);

  const val = args[1];
  if (2 === args.length) {
    lsSet(key, val);
    return lsGet(key, { quiet: true });
  }
};

quickfix.remove = (...args) => {
  if (!args.length) return;

  const key = k(args);
  if (!key) return;

  lsDel(key);
  return lsGet(key, { quiet: true });
};

export const QF_TIMELINE_ZONE = fromAnyToTrimmed(quickfix(1));
if (QF_TIMELINE_ZONE) L.info(1, QF_TIMELINE_ZONE);

export const QF_TIMELINE_OFFSET = fromAnyToInteger(quickfix(2));
if (QF_TIMELINE_OFFSET) L.info(2, QF_TIMELINE_OFFSET);

export default quickfix;
